import axios from 'axios'

export default {
  state: {},
  getters: {},
  actions: {
    getInfo (ctx, data) {
      return new Promise((resolve) => {
        axios.post('services/statistic', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getInfo2 (ctx, data) {
      return new Promise((resolve) => {
        axios.post('services/get', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          type: data.type
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getInfo3 (ctx, data) {
      return new Promise((resolve) => {
        axios.post('vrp/statistic', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          type: 'Турпоток'
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getInfo4 (ctx, data) {
      return new Promise((resolve) => {
        axios.post('vrp/get', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          type: 'Врп'
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    editInfo (ctx, data) {
      return new Promise((resolve) => {
        axios.post('services/edit', {
          data
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    newObject (ctx, data) {
      return new Promise((resolve) => {
        axios.post('services/create', {
          title: data[1],
          type: data[0],
          date_interval: 'month'
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
        })
      })
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/index/index.js